<template>
  <div class="content">
    <div class="top">
      <span>区域：</span>
      <el-select v-model="area">
        <el-option v-for="item in areaList" :label="item.divisionName" :value="item.id" :key="item.id"></el-option>
      </el-select>
      <span>周期：</span>
      <el-radio-group v-model="dateType" @change="changePeriod">
        <el-radio-button label="day">日</el-radio-button>
        <el-radio-button label="month">月</el-radio-button>
        <el-radio-button label="year">年</el-radio-button>
      </el-radio-group>
      <span>日期：</span>
      <el-date-picker
        v-model="date"
        :type="datePickerType"
        :picker-options="defaultDate"
        :format="dateFormat"
        :value-format="dateFormat"
        :clearable="false"
        :key="datePickerType">
      </el-date-picker>
      <el-button @click="getData">查询</el-button>
      <el-radio-group class="item-radio-group" v-model="tableType">
        <el-radio-button label="1">分项需量</el-radio-button>
        <el-radio-button label="2">区域需量</el-radio-button>
        <el-radio-button label="3">支路需量</el-radio-button>
      </el-radio-group>
    </div>
    <div class="middle">
      <corner-box class="pie-box">
        <div class="title-box">
          <div class="title fl">|最大需量</div>
          <div class="fr">
            <button class="fun" @click="download({title: '最大需量' ,selector:'#myPie'})">下载</button>
            <button class="fun" @click="print({title: '最大需量' ,selector:'#myPie'})">打印</button>
          </div>
        </div>
        <div id="myPie"></div>
      </corner-box>
      <div class="table-box">
        <el-table :data="tableData" border >
          <el-table-column  prop="categoryName"  :label="tableTitle.categoryName" ></el-table-column>
          <el-table-column  prop="maxData" :label="tableTitle.maxData" ></el-table-column>
          <el-table-column  prop="proportion" :label="tableTitle.proportion" ></el-table-column>
          <el-table-column  prop="avgEach" :label="tableTitle.avgEach" ></el-table-column>
          <el-table-column  prop="maxEach" :label="tableTitle.maxEach" ></el-table-column>
          <el-table-column  prop="maxTimeEach" :label="tableTitle.maxTimeEach" ></el-table-column>
        </el-table>
      </div>
    </div>
    <corner-box class="bottom">
      <div class="title-box">
        <div class="title fl">|需量曲线</div>
        <div class="fr">
          <button class="fun" @click="download({title: '需量曲线' ,selector:'#myLine'})">下载</button>
          <button class="fun" @click="print({title: '需量曲线' ,selector:'#myLine'})">打印</button>
        </div>
      </div>
      <div id="myLine"></div>
    </corner-box>
  </div>
</template>

<script>
import {getNowFormatDate} from '@/assets/js/tools/instruments'
import CornerBox from "@/components/cornerBox";
import {addResize,removeResize} from "../../assets/js/tools/echartsResize"
var echarts = require("echarts");

export default {
  name: "needAnalyse",
  components: {CornerBox},
  data(){
    return{
      area: '1',
      areaList: [],
      dateType: 'day',
      date: getNowFormatDate(),
      datePickerType: 'date',
      dateFormat: 'yyyy-MM-dd',
      defaultDate: {
        disabledDate: time => {
          return time.getTime() > new Date().getTime()
        }
      },
      tableType: '1',
      tableData: [],
      tableTitle: {
        categoryName: '',
        maxData: '',
        proportion: '',
        avgEach: '',
        maxEach: '',
        maxTimeEach: '',
      },
      pieData: [],
      xAxisList: [],
      lineLegend: [],
    }
  },
  mounted() {
    this.getData();
    this.getDivision();
  },
  methods:{
    getDivision(){
      this.$get('electricityreport/divisionlist').then((response)=>{
        this.areaList = response
      })
    },
    changePeriod(val){
      if(val == 'day'){
        this.datePickerType = 'date'
        this.dateFormat = 'yyyy-MM-dd'
        this.date = getNowFormatDate()
      }else if(val == 'month'){
        this.datePickerType = 'month'
        this.dateFormat = 'yyyy-MM'
        this.date = getNowFormatDate('month')
      }else{
        this.datePickerType = 'year'
        this.dateFormat = 'yyyy'
        this.date = getNowFormatDate('year').toString()
      }
    },
    getData(){
      this.lineLegend = [];
      this.lineData = [];
      this.$get('demandanalysis/getdemandanalysisdata',[this.area,this.tableType,this.dateType,this.date]).then((response)=>{
        let arr = [];
        //饼状图
        for(let i in response.maxDemandAnalysis){
          let obj = {};
          obj.name = response.maxDemandAnalysis[i].categoryName;
          obj.value = response.maxDemandAnalysis[i].maxData;
          arr.push(obj)
        }
        this.pieData = arr;
        this.pieTotal = response.maxDemandAnalysisTotal
          //表格
        this.tableData = response.tableOfDemandAnalysis.data;
        this.tableTitle.categoryName = response.tableOfDemandAnalysis.title[0]
        this.tableTitle.maxData = response.tableOfDemandAnalysis.title[1]
        this.tableTitle.proportion = response.tableOfDemandAnalysis.title[2]
        this.tableTitle.avgEach = response.tableOfDemandAnalysis.title[3]
        this.tableTitle.maxEach = response.tableOfDemandAnalysis.title[4]
        this.tableTitle.maxTimeEach = response.tableOfDemandAnalysis.title[5]
        //折线图
        this.xAxisList = response.curveOfDemandAnalysis.xAxis;
        let lie = response.curveOfDemandAnalysis.data
        for(let i in lie){
          lie[i].type = 'line'
          lie[i].symbol = 'circle'
          lie[i].symbolSize = 4
          this.lineLegend.push(lie[i].name)
        }
        this.lineData = lie;
        this.drawPie();
        this.drawLine();
      })
    },
    drawPie(){
      this.myPie = echarts.init(document.getElementById('myPie'))
      let _this = this;
      this.myPie.setOption({
        right: '5%',
        title: {
          text: '最大需量\n' + this.pieTotal+'kW',
          textAlign: 'center',
          // top: '95px',
          // left: '195px',
          x:'40%',
          y:'40%',
          textStyle: {
            color: '#909aa2'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} <br/>{a}: {c} ({d}%)'
        },
        legend: {
          top: 'middle',
          type:'scroll',
          right: '2%',
          orient: 'vertical',
          formatter:function(name){
            if(!name) return '';
            if(name.length > 6){
              name = name.slice(0,6)+ '...';
            }
            return name;
          },
          tooltip:{
              show:true
            },
          textStyle: {
            color: '#909aa2'
          }
        },
        series: [
          {
            name: '需量(kW)',
            type: 'pie',
            radius: ['60%', '80%'],
            // color: ['#4472c4','#ed7d31','#a5a5a5','#ffc000'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
                fontSize: '20',
              }
            },
            // emphasis: {
            //   label: {
            //     show: true,
            //     fontSize: '40',
            //     fontWeight: 'bold'
            //   }
            // },
            labelLine: {
              show: false
            },
            data: this.pieData,
            center: ['40%', '50%']
          }
        ]
      });
      // myPie.resize()
      addResize(this.myPie)
    },
    drawLine(){
      var myLine = echarts.init(document.getElementById('myLine'));
      myLine.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: this.lineLegend,
          textStyle: {
            color: '#909aa2'
          },
        },
        grid: {
          left: '1%',
          right: '3%',
          bottom: '2%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          axisLine: {
            lineStyle:{
              color: '#909aa2'
            }
          },
          minInterval: 1,
          axisLabel: {
            // interval: 2
          },
          data: this.xAxisList,
          //data: ['0时','1时', '2时', '3时', '4时', '5时', '6时', '7时', '8时', '9时', '10时', '11时', '12时', '13时', '14时', '15时', '16时', '17时', '18时', '19时', '20时', '21时', '22时', '23时']
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle:{
              color: '#909aa2'
            }
          },
          splitLine: {
            lineStyle:{
              color: 'rgba(255,255,255,0.3)'
            }
          },
        },
        series: this.lineData
      },true)
    },
    download(option){
      this.getPdf({'htmlTitle': option.title, 'selector': option.selector});

    },
    print(option){
      
      this.printHtml({'htmlTitle': option.title, 'selector': option.selector, 'type': 'canvas'});
    }
  }
}
</script>

<style scoped lang="scss">
.content{
  color: #fff;
  .top{
    margin: 0 auto;
    width: 98%;
    height: 50px;
    background-color: #081e30;
    line-height:50px;
    span{
      margin-left: 10px;
    }
    .el-button{
      margin-left: 10px;
    }
    .item-radio-group{
      float: right;
      margin-top: 10px;
    }
  }
  .middle{
    margin: 10px auto;
    width: 98%;
    height: 300px;
    display: flex;
    .pie-box{
      width: 34%;
      height: 100%;
      border: 1px solid #083550;
      margin-right: 10px;
      #myPie{
        width: 100%;
        height: 85%;
        margin-top: 35px;
      }
    }
    .table-box{
      width: 65%;
      height: 100%;
      .el-table{
        min-height: 100%;
      }
    }
  }
  .bottom{
    margin: 0 auto;
    height: 380px;
    width: 98%;
    border: 1px solid #083550;
    #myLine{
      width: 100%;
      height: 85%;
      margin-top: 30px;
    }
  }
  .title-box{
    padding: 5px;
  }
}
@media screen and (width:3440px) and (height: 1440px )   {
  
      .content {
        .middle{
          height: 455px;
        }
        .bottom{
          height: 700px;
        }
      }
    }
</style>
